import { render, staticRenderFns } from "./others.vue?vue&type=template&id=456d6578&scoped=true"
import script from "./others.vue?vue&type=script&lang=js"
export * from "./others.vue?vue&type=script&lang=js"
import style0 from "./others.vue?vue&type=style&index=0&id=456d6578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d6578",
  null
  
)

export default component.exports